import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './TermsPage.module.scss';

const TermsPage = () => {
    const navigate = useNavigate();
    const [openSection, setOpenSection] = useState(null);

    const toggleSection = (id) => {
        setOpenSection(openSection === id ? null : id);
    };

    const sections = [
        {
            id: 'general',
            title: 'Общие положения',
            content: `
                <h3>1.1. Принятие условий</h3>
                <p>Использование платформы NCORE означает полное и безоговорочное принятие настоящего пользовательского соглашения. Если вы не согласны с какими-либо условиями, пожалуйста, прекратите использование сервиса.</p>
                
                <h3>1.2. Изменения условий</h3>
                <p>Администрация NCORE оставляет за собой право изменять условия соглашения в одностороннем порядке. Все изменения вступают в силу с момента их публикации на сайте. Продолжая использовать платформу после внесения изменений, вы автоматически соглашаетесь с новыми условиями.</p>
                
                <h3>1.3. Возрастные ограничения</h3>
                <p>Для использования платформы необходимо достичь возраста 13 лет. Пользователи младше 18 лет должны получить согласие родителей или законных представителей.</p>
                
                <h3>1.4. Регистрация аккаунта</h3>
                <p>При регистрации вы обязуетесь предоставлять достоверную информацию. Вы несете полную ответственность за сохранность своих учетных данных и все действия, совершенные под вашей учетной записью.</p>
            `
        },
        {
            id: 'bonuses',
            title: 'Правила и условия использования бонусов',
            content: `
                <h3>2.1. Начисление баллов</h3>
                <p>Баллы начисляются за активность на платформе: регистрацию, участие в сообществе, выполнение заданий, игру на серверах и другие действия, определенные администрацией.</p>
                
                <h3>2.2. Использование баллов</h3>
                <p>Баллы можно использовать для покупки виртуальных товаров, услуг, подписок, игровых предметов и других продуктов, доступных в экосистеме NCORE. Баллы не имеют денежного эквивалента и не подлежат обмену на реальные деньги.</p>
                
                <h3>2.3. Срок действия баллов</h3>
                <p>Баллы действуют бессрочно, если иное не указано при их начислении. Администрация может установить срок действия для определенных типов баллов (промо-баллы, бонусы за акции).</p>
                
                <h3>2.4. Запрещенные действия</h3>
                <p>Запрещается получение баллов нечестным путем, включая использование ботов, эксплойтов, мультиаккаунтинг для выгоды, мошенничество. Нарушители будут лишены баллов и могут быть забанены.</p>
                
                <h3>2.5. Аннулирование баллов</h3>
                <p>Администрация оставляет за собой право аннулировать баллы, полученные нечестным путем, или в случае нарушения правил платформы.</p>
            `
        },
        {
            id: 'privacy',
            title: 'Политика конфиденциальности',
            content: `
                <h3>3.1. Сбор данных</h3>
                <p>Мы собираем информацию, которую вы предоставляете при регистрации: email, username, данные из социальных сетей (при авторизации через Google или Telegram). Также собираются данные об использовании платформы: IP-адрес, информация об устройстве, история активности.</p>
                
                <h3>3.2. Использование данных</h3>
                <p>Собранные данные используются для:</p>
                <ul>
                    <li>Обеспечения работы платформы и предоставления услуг</li>
                    <li>Улучшения пользовательского опыта</li>
                    <li>Персонализации контента</li>
                    <li>Анализа активности и статистики</li>
                    <li>Предотвращения мошенничества и нарушений</li>
                    <li>Рассылки уведомлений и новостей (с вашего согласия)</li>
                </ul>
                
                <h3>3.3. Защита данных</h3>
                <p>Мы применяем современные методы шифрования и защиты данных. Пароли хранятся в зашифрованном виде. Платежные данные обрабатываются через защищенные платежные системы.</p>
                
                <h3>3.4. Передача данных третьим лицам</h3>
                <p>Мы не продаем и не передаем ваши персональные данные третьим лицам, за исключением случаев:</p>
                <ul>
                    <li>Требования законодательства</li>
                    <li>Использования сервисов аналитики (Google Analytics, Yandex Metrika) - в анонимизированном виде</li>
                    <li>Интеграции с социальными сетями (по вашему согласию)</li>
                </ul>
                
                <h3>3.5. Cookies и отслеживание</h3>
                <p>Мы используем cookies для улучшения работы сайта, сохранения настроек и аналитики. Вы можете отключить cookies в настройках браузера, но это может ограничить функциональность платформы.</p>
                
                <h3>3.6. Ваши права</h3>
                <p>Вы имеете право запросить доступ к своим данным, их исправление или удаление. Для этого обратитесь в поддержку.</p>
            `
        },
        {
            id: 'cs2-servers',
            title: 'Правила игры на серверах CS2',
            content: `
                <h3>4.1. Общие правила поведения</h3>
                <p>На серверах CS2 запрещено:</p>
                <ul>
                    <li>Использование читов, хаков и любого стороннего ПО, дающего преимущество</li>
                    <li>Оскорбления, токсичное поведение, дискриминация по любому признаку</li>
                    <li>Спам в чате голосовом или текстовом</li>
                    <li>Блокирование тиммейтов, тимкилл (за исключением случайных)</li>
                    <li>Саботаж игры, намеренный проигрыш</li>
                    <li>Использование багов и эксплойтов карты</li>
                </ul>
                
                <h3>4.2. Система банов</h3>
                <p>За нарушения выдаются предупреждения, временные или постоянные баны в зависимости от тяжести нарушения:</p>
                <ul>
                    <li>Первое нарушение: предупреждение или бан на 24 часа</li>
                    <li>Повторное нарушение: бан на 7 дней</li>
                    <li>Систематические нарушения: бан на 30 дней или перманентный</li>
                    <li>Читы: моментальный перманентный бан</li>
                </ul>
                
                <h3>4.3. Игровые режимы</h3>
                <p>На серверах доступны различные режимы: классический 5x5, deathmatch, aim-карты, кастомные режимы. Соблюдайте специфичные правила каждого режима.</p>
                
                <h3>4.4. Администрирование</h3>
                <p>Решения администраторов и модераторов являются окончательными. Оспорить бан можно через систему поддержки с предоставлением доказательств.</p>
                
                <h3>4.5. Вознаграждения</h3>
                <p>За игру на серверах начисляются баллы. Размер вознаграждения зависит от времени игры, побед, MVP и других достижений.</p>
            `
        },
        {
            id: 'main-servers',
            title: 'Правила игры на основных серверах (Main)',
            content: `
                <h3>5.1. Minecraft сервер</h3>
                <p>На Minecraft сервере NCORE действуют следующие правила:</p>
                <ul>
                    <li>Запрещены читерские клиенты и моды, дающие преимущество (X-Ray, Fly и т.д.)</li>
                    <li>Запрещен гриф чужих построек без разрешения</li>
                    <li>Запрещены оскорбления и токсичность</li>
                    <li>Разрешены PvP в специальных зонах</li>
                    <li>Запрещена продажа игровых ресурсов за реальные деньги вне официальной системы</li>
                </ul>
                
                <h3>5.2. Discord сервер</h3>
                <p>На Discord сервере запрещено:</p>
                <ul>
                    <li>Спам и флуд в каналах</li>
                    <li>NSFW контент вне специальных каналов</li>
                    <li>Реклама сторонних проектов без разрешения</li>
                    <li>Использование ботов без разрешения администрации</li>
                    <li>Оскорбления и травля участников</li>
                </ul>
                
                <h3>5.3. Другие игровые сервера</h3>
                <p>На других игровых серверах (Rust, Valheim, другие игры) применяются общие правила поведения. Специфичные правила публикуются в описании каждого сервера.</p>
                
                <h3>5.4. Экономика серверов</h3>
                <p>На серверах действует внутренняя экономика, связанная с баллами NCORE. Вы можете зарабатывать баллы и тратить их на игровые предметы, донат-статусы, уникальные возможности.</p>
            `
        },
        {
            id: 'chats',
            title: 'Политика использования чатов и голосовых чатов',
            content: `
                <h3>6.1. Анонимность и приватность</h3>
                <p>Все чаты на платформе NCORE являются полностью анонимными. Мы не собираем, не храним и не анализируем содержимое ваших личных сообщений и голосовых разговоров. Сообщения шифруются end-to-end.</p>
                
                <h3>6.2. Правила общения в общих чатах</h3>
                <p>В общедоступных чатах и комнатах запрещено:</p>
                <ul>
                    <li>Публикация запрещенного контента (детская порнография, экстремизм, терроризм)</li>
                    <li>Массовые оскорбления и травля</li>
                    <li>Спам и реклама без разрешения</li>
                    <li>Распространение вредоносного ПО и вирусов</li>
                    <li>Попытки взлома или фишинга других пользователей</li>
                </ul>
                
                <h3>6.3. Модерация</h3>
                <p>Общие чаты модерируются администрацией. Жалобы на нарушения рассматриваются в течение 24 часов. Личные чаты не модерируются в соответствии с политикой полной анонимности.</p>
                
                <h3>6.4. Голосовые чаты</h3>
                <p>В голосовых чатах действуют те же правила что и в текстовых. Голосовые сообщения не записываются и не хранятся на серверах после завершения звонка.</p>
                
                <h3>6.5. Ваша ответственность</h3>
                <p>Вы несете полную ответственность за контент, который размещаете в чатах. Администрация не несет ответственности за действия пользователей в приватных чатах.</p>
                
                <h3>6.6. Удаление сообщений</h3>
                <p>Вы можете удалять свои сообщения в любое время. Удаленные сообщения не подлежат восстановлению.</p>
            `
        },
        {
            id: 'services',
            title: 'Условия использования сервисов',
            content: `
                <h3>7.1. Доступность сервисов</h3>
                <p>Администрация стремится обеспечить бесперебойную работу платформы 24/7, но не гарантирует абсолютную доступность. Возможны технические работы и сбои.</p>
                
                <h3>7.2. Ограничение ответственности</h3>
                <p>Платформа предоставляется "как есть". Мы не несем ответственности за любой ущерб, связанный с использованием сервисов, потерю данных или упущенную выгоду.</p>
                
                <h3>7.3. Интеллектуальная собственность</h3>
                <p>Все материалы платформы (дизайн, код, контент) защищены авторским правом. Запрещено копирование, распространение или коммерческое использование без разрешения.</p>
                
                <h3>7.4. Пользовательский контент</h3>
                <p>Загружая контент на платформу, вы предоставляете нам неисключительную лицензию на его использование в рамках работы сервисов. Вы остаетесь правообладателем своего контента.</p>
            `
        },
        {
            id: 'payments',
            title: 'Платежи и возвраты',
            content: `
                <h3>8.1. Оплата услуг</h3>
                <p>Некоторые услуги и товары платформы доступны за баллы или реальные деньги. Цены указываются в рублях или другой валюте на момент покупки.</p>
                
                <h3>8.2. Способы оплаты</h3>
                <p>Мы принимаем оплату через банковские карты, электронные кошельки, криптовалюту и другие методы, доступные на платформе.</p>
                
                <h3>8.3. Возврат средств</h3>
                <p>Возврат средств возможен в течение 14 дней с момента покупки при наличии веской причины и в соответствии с законодательством. Виртуальные товары и услуги после использования возврату не подлежат.</p>
                
                <h3>8.4. Отмена подписки</h3>
                <p>Вы можете отменить подписку в любое время. Средства за неиспользованный период не возвращаются, но доступ к premium-функциям сохраняется до конца оплаченного периода.</p>
            `
        },
        {
            id: 'termination',
            title: 'Прекращение использования',
            content: `
                <h3>9.1. Удаление аккаунта</h3>
                <p>Вы можете удалить свой аккаунт в любое время через настройки профиля. После удаления все данные будут безвозвратно стерты в течение 30 дней.</p>
                
                <h3>9.2. Блокировка аккаунта</h3>
                <p>Администрация имеет право заблокировать аккаунт при нарушении правил платформы без предварительного уведомления и возврата средств.</p>
                
                <h3>9.3. Закрытие платформы</h3>
                <p>В случае прекращения работы платформы, администрация уведомит пользователей за 30 дней. Неиспользованные баллы не подлежат компенсации.</p>
            `
        },
        {
            id: 'contact',
            title: 'Дата последнего обновления',
            content: `
                 <h3>10.1. Дата последнего обновления</h3>
                <p>Настоящее соглашение обновлено: ${new Date().toLocaleDateString('ru-RU')}</p>
            `
        }
    ];

    return (
        <div className={styles.wrapper}>
            <button onClick={() => navigate(-1)} className={styles.backButton}>
                ← Назад
            </button>

            <div className={styles.container}>
                <h1 className={styles.title}>Пользовательское соглашение</h1>
                <p className={styles.subtitle}>
                    Условия использования платформы NCORE
                </p>

                <div className={styles.accordionContainer}>
                    {sections.map((section) => (
                        <div 
                            key={section.id} 
                            className={`${styles.accordionItem} ${openSection === section.id ? styles.open : ''}`}
                        >
                            <button 
                                className={styles.accordionHeader}
                                onClick={() => toggleSection(section.id)}
                            >
                                <span className={styles.accordionTitle}>{section.title}</span>
                                <span className={styles.accordionIcon}>
                                    {openSection === section.id ? '−' : '+'}
                                </span>
                            </button>
                            {openSection === section.id && (
                                <div 
                                    className={styles.accordionContent}
                                    dangerouslySetInnerHTML={{ __html: section.content }}
                                />
                            )}
                        </div>
                    ))}
                </div>

                <div className={styles.footer}>
                    <p>Используя платформу NCORE, вы подтверждаете, что прочитали, поняли и согласны с настоящим пользовательским соглашением.</p>
                    <p className={styles.lastUpdate}>Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;
